module.exports = __webpack_public_path__ + "media/proksee-viewer/images/cb-move-right-8c636c4effb8d6e009b983554779e511.png";